import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { AppState } from 'store/app/appReducer';

const selectAppState = (state: RootState) => state.app;

export const selectThemeMode = createSelector(
  selectAppState,
  (appState: AppState) => appState.themeMode,
);
